/* ─────────────────────────────────────────────────────────────────────────────
   GrowthOS migration — Pipeline Funnel (All) — RTK Query slice. One payload
   (the reference getPipelineFunnel shape): ladder steps, pipeline × stage
   matrix, step drill, leakage, stalled deals and the lead→deal→stage→outcome
   flow, all from real GrowthOsDeal + GrowthOsContact data.
   ──────────────────────────────────────────────────────────────────────────── */
import { createApi } from '@reduxjs/toolkit/query/react'
import { apiConstants, get } from '../common/constants'

const PIPELINE_FUNNEL = apiConstants.GROWTHOS_ADMIN_PIPELINE_FUNNEL

const run = async (promise) => {
  try {
    const res = await promise
    return { data: res?.data }
  } catch (err) {
    const r = err?.response
    return {
      error: {
        status: r?.status,
        data: r?.data,
        message: r?.data?.message || err.message,
      },
    }
  }
}

export const growthosPipelineFunnelApiSlice = createApi({
  reducerPath: 'growthosPipelineFunnelApi',
  baseQuery: () => ({ data: undefined }),
  tagTypes: ['PipelineFunnel'],
  endpoints: (b) => ({
    getPipelineFunnel: b.query({
      queryFn: ({ period, from, to }) => run(get(PIPELINE_FUNNEL, { period, from, to })),
      providesTags: ['PipelineFunnel'],
    }),
  }),
})

export const { useGetPipelineFunnelQuery } = growthosPipelineFunnelApiSlice
